import React, { useState, useEffect } from 'react';
import { auth } from '../firebase';

const UploadCSV = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [userEmail, setUserEmail] = useState('');

  // Allowed email addresses
  const allowedEmails = [
    'anand.pathak@digiadglobal.com',
    'sales@digidayin.com',
    'shridhar.mishra@digiadglobal.com',
    'ashish.gupta@digiadglobal.com'
  ];

  // Get currently authenticated user
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setUserEmail(user ? user.email : '');
    });
    return () => unsubscribe();
  }, []);

  // Handle file input change
  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  // Upload file to backend API
  const handleUpload = async () => {
    if (!allowedEmails.includes(userEmail)) {
      alert('Unauthorized: You are not allowed to upload CSV files.');
      return;
    }

    if (!selectedFile) {
      alert('Please select a CSV file.');
      return;
    }

    setUploading(true);

    const formData = new FormData();
    const timestamp = Date.now();
    const s3Key = `uploads/${timestamp}-${selectedFile.name}`;

    formData.append('file', selectedFile);
    formData.append('s3_key', s3Key);
    formData.append('email', userEmail);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/engage/api/csv/upload`, {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        alert('CSV uploaded successfully!');
        console.log('S3 Location:', result.location);
        setSelectedFile(null);
      } else {
        console.error('Upload error response:', result);
        alert(result.error || 'Upload failed. Check console for details.');
      }
    } catch (err) {
      console.error('Upload failed:', err);
      alert('An error occurred while uploading the CSV file.');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="p-4 bg-white rounded shadow">
      <h2 className="text-xl font-semibold mb-4">Upload CSV File</h2>

      <p className="mb-2 text-gray-600">Logged in as: <strong>{userEmail || 'Not logged in'}</strong></p>

      {!allowedEmails.includes(userEmail) && (
        <p className="text-red-500 mb-4">You are not authorized to upload CSV files.</p>
      )}

      <input
        type="file"
        accept=".csv"
        onChange={handleFileChange}
        disabled={!allowedEmails.includes(userEmail)}
        className="mb-4"
      />

      <button
        onClick={handleUpload}
        disabled={!selectedFile || uploading || !allowedEmails.includes(userEmail)}
        className={`px-4 py-2 rounded text-white ${uploading ? 'bg-gray-400' : 'bg-blue-600 hover:bg-blue-700'}`}
      >
        {uploading ? 'Uploading...' : 'Upload CSV'}
      </button>
    </div>
  );
};

export default UploadCSV;
